module.exports = __webpack_public_path__ + "media/images/confluence-1225a7ba29bf4a9b2eaa813353ac178a.png";